import React from "react";
import { useTranslation } from "react-i18next";
import { useSubscriptionAccess } from "../../Context/SubscriptionAccessContext";

const QUICK_ACTIONS = [
  {
    to: "/api-generator",
    icon: "⚡",
    titleKey: "Generate New API",
    subKey: "Build an endpoint from any Odoo model",
    requiresActiveSubscription: true
  },
  {
    to: "/engine-config",
    icon: "🔗",
    titleKey: "Add Odoo Connection",
    subKey: "Connect a new Odoo instance or database",
    requiresActiveSubscription: true
  },
  {
    to: "/gettoken",
    icon: "🪙",
    titleKey: "Top Up Tokens",
    subKey: "Purchase more API call credits",
    requiresActiveSubscription: true
  },
  {
    to: "/my-apis",
    icon: "📋",
    titleKey: "Manage My APIs",
    subKey: "View, edit and test your endpoints"
  }
];

const HomeQuickActions = () => {
  const { t } = useTranslation("common");
  const {
    checking,
    navigateWithSubscriptionCheck,
    isRestrictedMenuDisabled
  } = useSubscriptionAccess();

  const handleAction = async (event, path) => {
    event.preventDefault();
    if (isRestrictedMenuDisabled(path) || checking) return;
    await navigateWithSubscriptionCheck(path);
  };

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <div className="card-title">{t("Quick Actions")}</div>
          <div className="card-subtitle">{t("Jump to your most-used tools")}</div>
        </div>
      </div>
      <div className="qa-list">
        {QUICK_ACTIONS.map((action) => {
          const disabled = isRestrictedMenuDisabled(action.to);
          if (disabled) {
            return (
              <span
                key={action.to}
                className="btn btn-ghost btn-full qa-item qa-item-disabled"
                aria-disabled="true"
                title={t("Renew your subscription to access this feature.")}>
                <span className="qa-icon">{action.icon}</span>
                <div>
                  <div className="qa-title">{t(action.titleKey)}</div>
                  <div className="qa-sub">{t(action.subKey)}</div>
                </div>
              </span>
            );
          }

          return (
            <a
              key={action.to}
              href={action.to}
              className="btn btn-ghost btn-full qa-item"
              onClick={(event) => handleAction(event, action.to)}>
              <span className="qa-icon">{action.icon}</span>
              <div>
                <div className="qa-title">{t(action.titleKey)}</div>
                <div className="qa-sub">{t(action.subKey)}</div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default HomeQuickActions;
